import { supabase } from '../lib/supabase';

// Complete floor data as provided by user
const completeFloorData = [
  // Ground Floor (1-10)
  {
    number: "1",
    residents: [],
    isExpanded: false
  },
  {
    number: "2",
    residents: [{
      id: "2-1",
      name: "Afifah Hardi",
      phone: "+62 852-6549-0966",
      study: "Statistika 2022",
      position: 1,
      paymentPattern: 3,
      startDate: "2024-02-15",
      paymentPeriods: [
        {
          id: "2-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-02-15",
          paymentProofDate: "2024-11-14",
          paymentProofLink: "https://iili.io/2e7Xx44.jpg",
          nextPaymentDate: "2025-02-15"
        },
        {
          id: "2-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-15",
          paymentProofDate: "2025-02-15",
          paymentProofLink: "https://iili.io/32eE9nt.jpg",
          nextPaymentDate: "2025-05-15"
        },
        {
          id: "2-1-3",
          periodNumber: 3,
          dpDate: "",
          startDate: "2025-05-15",
          paymentProofDate: "2025-05-14",
          paymentProofLink: "https://cdn.imgchest.com/files/7lxcpzvjlk7.jpeg",
          nextPaymentDate: "2025-08-15"
        }
      ],
      roomNumber: "2",
      nextPaymentDate: "2025-08-15"
    }],
    isExpanded: false
  },
  {
    number: "3",
    residents: [{
      id: "3-1",
      name: "Azizah Thahirah",
      phone: "089514443372",
      study: "Pendidikan IPA 2021",
      position: 1,
      paymentPattern: 1,
      startDate: "2024-02-01",
      paymentPeriods: [
        {
          id: "3-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-02-01",
          paymentProofDate: "2024-12-02",
          paymentProofLink: "https://iili.io/2kqr2Sf.jpg",
          nextPaymentDate: "2025-01-02"
        },
        {
          id: "3-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-01-02",
          paymentProofDate: "2025-01-03",
          paymentProofLink: "https://iili.io/2SiNpUl.jpg",
          nextPaymentDate: "2025-02-02"
        },
        {
          id: "3-1-3",
          periodNumber: 3,
          dpDate: "",
          startDate: "2025-02-02",
          paymentProofDate: "2025-02-04",
          paymentProofLink: "https://iili.io/2tLZJet.jpg",
          nextPaymentDate: "2025-03-01"
        },
        {
          id: "3-1-4",
          periodNumber: 4,
          dpDate: "",
          startDate: "2025-03-01",
          paymentProofDate: "2025-03-06",
          paymentProofLink: "https://iili.io/3oPTcnS.jpg",
          nextPaymentDate: "2025-04-01"
        },
        {
          id: "3-1-5",
          periodNumber: 5,
          dpDate: "",
          startDate: "2025-04-01",
          paymentProofDate: "2025-04-08",
          paymentProofLink: "https://iili.io/3ldVmuV.jpg",
          nextPaymentDate: "2025-05-01"
        },
        {
          id: "3-1-6",
          periodNumber: 6,
          dpDate: "",
          startDate: "2025-05-01",
          paymentProofDate: "2025-05-02",
          paymentProofLink: "https://cdn.imgchest.com/files/7mmc9mbq8e7.jpeg",
          nextPaymentDate: "2025-06-01"
        },
        {
          id: "3-1-7",
          periodNumber: 7,
          dpDate: "",
          startDate: "2025-06-02",
          paymentProofDate: "2025-06-02",
          paymentProofLink: "https://cdn.imgchest.com/files/7pjcqorj2x7.jpeg",
          nextPaymentDate: "2025-07-01"
        }
      ],
      roomNumber: "3",
      nextPaymentDate: "2025-07-01"
    }],
    isExpanded: false
  },
  {
    number: "4",
    residents: [{
      id: "4-1",
      name: "Devina Shafira Maharani",
      phone: "082384484189",
      study: "Pend MTK 2022",
      position: 1,
      paymentPattern: 3,
      paymentPeriods: [
        {
          id: "4-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2023-08-20",
          paymentProofDate: "2025-01-03",
          paymentProofLink: "https://iili.io/2SLLtqv.jpg",
          nextPaymentDate: "2025-01-20"
        },
        {
          id: "4-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-04-20",
          paymentProofDate: "2025-03-18",
          paymentProofLink: "https://iili.io/3oPwJvj.jpg",
          nextPaymentDate: "2025-04-20"
        }
      ],
      roomNumber: "4",
      startDate: "2023-08-20",
      nextPaymentDate: "2025-07-20"
    }],
    isExpanded: false
  },
  {
    number: "5",
    residents: [{
      id: "5-1",
      name: "Vani Syahfitri",
      phone: "+62 853-8495-8517",
      study: "Pend Fisika 2024",
      position: 1,
      paymentPattern: 6,
      startDate: "2025-04-10",
      paymentPeriods: [
        {
          id: "5-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2025-04-10",
          paymentProofDate: "2025-04-10",
          paymentProofLink: "https://cdn.imgchest.com/files/7bwckvk6mj7.jpeg",
          nextPaymentDate: "2025-10-10"
        }
      ],
      roomNumber: "5",
      nextPaymentDate: "2025-10-10"
    }],
    isExpanded: false
  },
  {
    number: "6",
    residents: [{
      id: "6-1",
      name: "(booking menunggu datang)",
      phone: "",
      study: "",
      position: 1,
      paymentPattern: 2,
      startDate: "2025-02-25",
      paymentPeriods: [
        {
          id: "6-1-1",
          periodNumber: 1,
          dpDate: "2025-01-28",
          startDate: "2025-02-25",
          paymentProofDate: "2025-01-28",
          paymentProofLink: "https://iili.io/2Q1N8qx.jpg",
          nextPaymentDate: "2025-04-25"
        },
        {
          id: "6-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-04-25",
          paymentProofDate: "2025-02-22",
          paymentProofLink: "https://iili.io/3HfmLt2.jpg",
          nextPaymentDate: "2025-06-25"
        }
      ],
      roomNumber: "6",
      nextPaymentDate: "2025-06-25"
    }],
    isExpanded: false
  },
  {
    number: "7",
    residents: [{
      id: "7-1",
      name: "Hanifah Zahra Arsa",
      phone: "+62 822-9958-7839",
      study: "Kimia NK 20",
      position: 1,
      paymentPattern: 3,
      paymentPeriods: [
        {
          id: "7-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2023-12-15",
          paymentProofDate: "2024-11-08",
          paymentProofLink: "https://iili.io/2SQd0XV.jpg",
          nextPaymentDate: "2025-02-15"
        },
        {
          id: "7-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-15",
          paymentProofDate: "2025-02-12",
          paymentProofLink: "https://iili.io/3HfvFCN.jpg",
          nextPaymentDate: "2025-05-15"
        },
        {
          id: "7-1-3",
          periodNumber: 3,
          dpDate: "",
          startDate: "2025-05-15",
          paymentProofDate: "2025-05-14",
          paymentProofLink: "https://cdn.imgchest.com/files/y8xcn9ogao4.jpeg",
          nextPaymentDate: "2025-08-14"
        }
      ],
      roomNumber: "7",
      startDate: "2023-12-15",
      nextPaymentDate: "2025-08-14"
    }],
    isExpanded: false
  },
  {
    number: "8",
    residents: [{
      id: "8-1",
      name: "Selvia Salsabilla",
      phone: "+62 819-1025-0691",
      study: "Pendidikan Matematika 2022",
      position: 1,
      paymentPattern: 12,
      startDate: "2024-08-26",
      paymentPeriods: [
        {
          id: "8-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-08-26",
          paymentProofDate: "2024-08-26",
          paymentProofLink: "https://iili.io/26HQXXS.jpg",
          nextPaymentDate: "2025-08-26"
        }
      ],
      roomNumber: "8",
      nextPaymentDate: "2025-08-26"
    }],
    isExpanded: false
  },
  {
    number: "9",
    residents: [
      {
        id: "9-1",
        name: "Kanya Tri Anggita",
        phone: "0895621911819",
        study: "BP: 2025",
        position: 1,
        paymentPattern: 1,
        startDate: "2025-05-16",
        paymentPeriods: [],
        roomNumber: "9",
        nextPaymentDate: "2025-06-16"
      }
    ],
    isExpanded: false
  },
  {
    number: "10",
    residents: [{
      id: "10-1",
      name: "Imraatul Khairati",
      phone: "085274006326",
      study: "Sastra Inggris 19",
      position: 1,
      paymentPattern: 1,
      paymentPeriods: [
        {
          id: "10-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-12-20",
          paymentProofDate: "2025-01-13",
          paymentProofLink: "https://iili.io/2idyVig.jpg",
          nextPaymentDate: "2025-02-20"
        },
        {
          id: "10-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2024-12-20",
          paymentProofDate: "2025-02-13",
          paymentProofLink: "https://iili.io/32eT9CQ.jpg",
          nextPaymentDate: "2025-03-20"
        },
        {
          id: "10-1-3",
          periodNumber: 3,
          dpDate: "",
          startDate: "2025-03-20",
          paymentProofDate: "2025-03-13",
          paymentProofLink: "https://iili.io/3ldtqt2.jpg",
          nextPaymentDate: "2025-04-20"
        },
        {
          id: "10-1-4",
          periodNumber: 4,
          dpDate: "",
          startDate: "2025-04-20",
          paymentProofDate: "2025-04-13",
          paymentProofLink: "https://cdn.imgchest.com/files/yrgcnwn88o4.jpeg",
          nextPaymentDate: "2025-05-20"
        },
        {
          id: "10-1-5",
          periodNumber: 5,
          dpDate: "",
          startDate: "2025-05-20",
          paymentProofDate: "2025-05-13",
          paymentProofLink: "https://cdn.imgchest.com/files/yvdcwopqnxy.jpeg",
          nextPaymentDate: "2025-06-20"
        }
      ],
      roomNumber: "10",
      startDate: "2024-12-20",
      nextPaymentDate: "2025-06-20"
    }],
    isExpanded: false
  },
  // First Floor (101-108)
  {
    number: "101",
    residents: [],
    isExpanded: false
  },
  {
    number: "102",
    residents: [
      {
        id: "102-1",
        name: "Najwa Fatih Farrokhah",
        phone: "085769743839 (WA), 081532247730 (telp)",
        study: "BP: 2025",
        position: 1,
        paymentPattern: 1,
        startDate: "2025-05-16",
        paymentPeriods: [],
        roomNumber: "102",
        nextPaymentDate: "2025-06-16"
      },
      {
        id: "102-2",
        name: "Rezki Naswa Dani",
        phone: "085609422589",
        study: "BP: 2025",
        position: 2,
        paymentPattern: 1,
        startDate: "2025-05-16",
        paymentPeriods: [],
        roomNumber: "102",
        nextPaymentDate: "2025-06-16"
      }
    ],
    isExpanded: false
  },
  {
    number: "103",
    residents: [
      {
        id: "103-1",
        name: "Fauziah Azzaahraa",
        phone: "+6288271078757",
        study: "Pend. Biologi 23",
        position: 1,
        paymentPattern: 4,
        paymentPeriods: [
          {
            id: "103-1-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-08-15",
            paymentProofDate: "2024-11-15",
            paymentProofLink: "https://iili.io/2SQYaX2.jpg",
            nextPaymentDate: "2025-03-15"
          }
        ],
        roomNumber: "103",
        startDate: "2024-08-15",
        nextPaymentDate: "2025-03-15"
      }
    ],
    isExpanded: false
  },
  {
    number: "104",
    residents: [],
    isExpanded: false
  },
  {
    number: "105",
    residents: [
      {
        id: "105-1",
        name: "Ibtihal Istiqomah",
        phone: "+62 823-9109-6548",
        study: "Pendidikan Agama Islam S2",
        position: 1,
        paymentPattern: 1,
        startDate: "2025-02-12",
        paymentPeriods: [
          {
            id: "105-1-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2025-02-12",
            paymentProofDate: "2025-02-12",
            paymentProofLink: "https://iili.io/32eQvuj.jpg",
            nextPaymentDate: "2025-03-12"
          },
          {
            id: "105-1-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-02-12",
            paymentProofDate: "2025-03-17",
            paymentProofLink: "https://cdn.imgchest.com/files/7ogcbqlwb8y.jpeg",
            nextPaymentDate: "2025-04-12"
          },
          {
            id: "105-1-3",
            periodNumber: 3,
            dpDate: "",
            startDate: "2025-02-12",
            paymentProofDate: "2025-04-14",
            paymentProofLink: "https://cdn.imgchest.com/files/45xcvgzqvx7.jpeg",
            nextPaymentDate: "2025-05-12"
          },
          {
            id: "105-1-4",
            periodNumber: 4,
            dpDate: "",
            startDate: "2025-05-12",
            paymentProofDate: "2025-05-17",
            paymentProofLink: "https://cdn.imgchest.com/files/46acq9xzpv7.jpeg",
            nextPaymentDate: "2025-06-12"
          }
        ],
        roomNumber: "105",
        nextPaymentDate: "2025-06-12"
      }
    ],
    isExpanded: false
  },
  {
    number: "106 (AC)",
    residents: [],
    isExpanded: false
  },
  {
    number: "107",
    residents: [],
    isExpanded: false
  },
  {
    number: "108",
    residents: [
      {
        id: "108-1",
        name: "Hasna Luthifah",
        phone: "082288360656",
        study: "Pendidikan Biologi 2020",
        position: 1,
        paymentPattern: 1,
        startDate: "2024-12-19",
        paymentPeriods: [
          {
            id: "108-1-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-12-19",
            paymentProofDate: "2024-12-19",
            paymentProofLink: "https://iili.io/2UB3WQa.jpg",
            nextPaymentDate: "2025-02-20"
          },
          {
            id: "108-1-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2024-12-19",
            paymentProofDate: "2025-01-19",
            paymentProofLink: "https://iili.io/2i2cj5J.jpg",
            nextPaymentDate: "2025-02-20"
          },
          {
            id: "108-1-3",
            periodNumber: 3,
            dpDate: "",
            startDate: "2024-12-19",
            paymentProofDate: "2025-02-19",
            paymentProofLink: "https://iili.io/32eui79.jpg",
            nextPaymentDate: "2025-03-20"
          },
          {
            id: "108-1-4",
            periodNumber: 4,
            dpDate: "",
            startDate: "2024-12-19",
            paymentProofDate: "2025-03-19",
            paymentProofLink: "https://iili.io/3zTb0Hx.jpg", 
            nextPaymentDate: "2025-04-20"
          },
          {
            id: "108-1-5",
            periodNumber: 5,
            dpDate: "",
            startDate: "2024-12-19",
            paymentProofDate: "2025-04-19",
            paymentProofLink: "https://cdn.imgchest.com/files/y8xcnwk2rn4.jpeg",
            nextPaymentDate: "2025-05-19"
          },
          {
            id: "108-1-6",
            periodNumber: 6,
            dpDate: "",
            startDate: "2025-05-19",
            paymentProofDate: "2025-05-19",
            paymentProofLink: "https://cdn.imgchest.com/files/7lxcpnk3567.jpeg",
            nextPaymentDate: "2025-06-19"
          }
        ],
        roomNumber: "108",
        nextPaymentDate: "2025-06-19"
      }
    ],
    isExpanded: false
  },
  // Second Floor (200-212)
  {
    number: "200",
    residents: [],
    isExpanded: false
  },
  {
    number: "201",
    residents: [{
      id: "201-1",
      name: "Tiara",
      phone: "082215781599",
      study: "Kimia NK/2021",
      position: 1,
      paymentPattern: 4,
      paymentPeriods: [
        {
          id: "201-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-05-06",
          paymentProofDate: "2024-05-06",
          paymentProofLink: "https://iili.io/2SLTRyB.jpg",
          nextPaymentDate: "2025-05-06"
        },
        {
          id: "201-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-05-06",
          paymentProofDate: "2025-05-09",
          paymentProofLink: "https://cdn.imgchest.com/files/yrgcnooxlb4.jpeg",
          nextPaymentDate: "2025-09-09"
        }
      ],
      roomNumber: "201",
      startDate: "2024-05-06",
      nextPaymentDate: "2025-09-09"
    }],
    isExpanded: false
  },
  {
    number: "202",
    residents: [
      {
      id: "202-1",
      name: "Alya Salsabilla Putri",
      phone: "083177325330",
      study: "Teknik Pertambangan 23",
      position: 1,
      paymentPattern: 4,
      paymentPeriods: [
        {
          id: "202-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2025-04-23",
          paymentProofDate: "2025-04-27",
          paymentProofLink: "https://cdn.imgchest.com/files/yq9c389apr4.jpeg",
          nextPaymentDate: "2025-08-23"
        }
      ],
      roomNumber: "202",
      startDate: "2024-12-23",
      nextPaymentDate: "2025-08-23"
      },
      {
      id: "202-2",
      name: "Afifah Viola Rezki",
      phone: "082172771096",
      study: "Pendidikan Bahasa Inggris 23",
      position: 2,
      paymentPattern: 4,
      paymentPeriods: [
        {
          id: "202-2-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-12-23",
          paymentProofDate: "2024-12-23",
          paymentProofLink: "https://iili.io/26M8iLg.jpg",
          nextPaymentDate: "2025-04-23"
        },
        {
          id: "202-2-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-04-23",
          paymentProofDate: "2025-04-26",
          paymentProofLink: "https://cdn.imgchest.com/files/ye3c2je2qr4.jpeg",
          nextPaymentDate: "2025-08-23"
        }
      ],
      roomNumber: "202",
      startDate: "2024-12-23",
      nextPaymentDate: "2025-08-26"
      }
    ],
    isExpanded: false
  },
  {
    number: "203",
    residents: [
      {
      id: "203-1",
      name: "Emelia Putri",
      phone: "0823857416",
      study: "Teknik Pertambangan 23",
      position: 1,
      paymentPattern: 4,
      paymentPeriods: [
        {
          id: "203-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-10-04",
          paymentProofDate: "2024-10-04",
          paymentProofLink: "https://iili.io/26M8iLg.jpg",
          nextPaymentDate: "2025-02-05"
        },
        {
          id: "203-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-05",
          paymentProofDate: "2025-02-05",
          paymentProofLink: "https://iili.io/2tLPcnR.jpg",
          nextPaymentDate: "2025-06-05"
        },
        {
          id: "203-1-3",
          periodNumber: 3,
          dpDate: "",
          startDate: "2025-06-05",
          paymentProofDate: "2025-06-05",
          paymentProofLink: "https://cdn.imgchest.com/files/yvdcwopq3by.jpeg",
          nextPaymentDate: "2025-10-05"
        }
      ],
      roomNumber: "203",
      startDate: "2024-10-04",
      nextPaymentDate: "2025-10-05"
      },
      {
      id: "203-2",
      name: "Raysha Hanifah",
      phone: "082320904965",
      study: "Kimia NK 24",
      position: 2,
      paymentPattern: 6,
      paymentPeriods: [
        {
          id: "203-2-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-08-11",
          paymentProofDate: "2024-08-11",
          paymentProofLink: "https://iili.io/26VFUiX.jpg, https://iili.io/26VKMml.jpg, https://iili.io/26VfnQS.jpg",
          nextPaymentDate: "2025-02-11"
        },
        {
          id: "203-2-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-11",
          paymentProofDate: "2025-02-10",
          paymentProofLink: "https://iili.io/3Hf49yX.jpg",
          nextPaymentDate: "2025-08-11"
        }
      ],
      roomNumber: "203",
      startDate: "2024-08-11",
      nextPaymentDate: "2025-08-11"
      }
    ],
    isExpanded: false
  },
  {
    number: "204",
    residents: [{
      id: "204-1",
      name: "Khairunisa",
      phone: "081267012623",
      study: "Biologi NK/2021",
      position: 1,
      paymentPattern: 1,
      paymentPeriods: [
        {
          id: "204-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2023-12-15",
          paymentProofDate: "2025-01-03",
          paymentProofLink: "https://iili.io/2SLmoxt.jpg",
          nextPaymentDate: "2025-02-15"
        },
        {
          id: "204-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-15",
          paymentProofDate: "2025-02-01",
          paymentProofLink: "https://iili.io/2Zrz1cB.jpg",
          nextPaymentDate: "2025-03-15"
        },
        {
          id: "204-1-3",
          periodNumber: 3,
          dpDate: "",
          startDate: "2025-03-15",
          paymentProofDate: "2025-03-04",
          paymentProofLink: "https://iili.io/3a19fz7.jpg",
          nextPaymentDate: "2025-04-15"
        },
        {
          id: "204-1-4",
          periodNumber: 4,
          dpDate: "",
          startDate: "2025-04-15",
          paymentProofDate: "2025-04-10",
          paymentProofLink: "https://iili.io/3a1H69R.jpg",
          nextPaymentDate: "2025-05-15"
        },
        {
          id: "204-1-5",
          periodNumber: 5,
          dpDate: "",
          startDate: "2025-05-15",
          paymentProofDate: "2025-05-03",
          paymentProofLink: "https://cdn.imgchest.com/files/7w6c2pdne8y.jpeg",
          nextPaymentDate: "2025-06-15"
        }
      ],
      roomNumber: "204",
      startDate: "2023-12-15",
      nextPaymentDate: "2025-06-15"
    }],
    isExpanded: false
  },
  {
    number: "205",
    residents: [
      {
      id: "205-1",
      name: "Asyifa Putri Etira",
      phone: "+62 838-0061-3724",
      study: "Pendidikan Fisika 24",
      position: 1,
      paymentPattern: 1,
      paymentPeriods: [
        {
          id: "205-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-08-15",
          paymentProofDate: "2024-08-16",
          paymentProofLink: "https://iili.io/26VvhEG.jpg, https://iili.io/26V8rNI.jpg",
          nextPaymentDate: "2025-02-15"
        },
        {
          id: "205-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-15",
          paymentProofDate: "2025-02-16",
          paymentProofLink: "https://iili.io/32e4nYx.jpg",
          nextPaymentDate: "2025-08-15"
        }
      ],
      roomNumber: "205",
      startDate: "2024-08-15",
      nextPaymentDate: "2025-08-15"
      },
      {
      id: "205-2",
      name: "Sani Safitri",
      phone: "+62 823-2027-0569",
      study: "Pendidikan Fisika 2024",
      position: 2,
      paymentPattern: 6,
      paymentPeriods: [
        {
          id: "205-2-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-08-15",
          paymentProofDate: "2024-08-15",
          paymentProofLink: "https://iili.io/26VvhEG.jpg, https://iili.io/26V8rNI.jpg",
          nextPaymentDate: "2025-02-15"
        },
        {
          id: "205-2-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-15",
          paymentProofDate: "2025-02-15",
          paymentProofLink: "https://iili.io/32e4nYx.jpg",
          nextPaymentDate: "2025-08-15"
        }
      ],
      roomNumber: "205",
      startDate: "2024-08-15",
      nextPaymentDate: "2025-08-15"
      }
    ],
    isExpanded: false
  },
  {
    number: "206",
    residents: [
      {
      id: "206-1",
      name: "Ghina Nur Azizah Thamrin",
      phone: "+62 813-8273-7254",
      study: "Pend Mtk 24",
      position: 1,
      paymentPattern: 6,
      paymentPeriods: [
        {
          id: "206-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-08-19",
          paymentProofDate: "2024-08-02",
          paymentProofLink: "https://iili.io/26WMDes.jpg",
          nextPaymentDate: "2025-02-19"
        },
        {
          id: "206-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-19",
          paymentProofDate: "2025-02-05",
          paymentProofLink: "https://iili.io/39mYZ2S.jpg",
          nextPaymentDate: "2025-08-19"
        }
      ],
      roomNumber: "206",
      startDate: "2024-08-19",
      nextPaymentDate: "2025-08-19"
      }
    ],
    isExpanded: false
  },
  {
    number: "207",
    residents: [],
    isExpanded: false
  },
  {
    number: "208",
    residents: [
      {
        id: "208-1",
        name: "Nabila Sari",
        phone: "+62 896-3121-0506",
        study: "Pendidikan MTK 21",
        position: 1,
        paymentPattern: 6,
        paymentPeriods: [
          {
            id: "208-1-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2025-01-05",
            paymentProofDate: "2025-01-05",
            paymentProofLink: "https://iili.io/2idXF4V.jpg",
            nextPaymentDate: "2025-07-05"
          }
        ],
        roomNumber: "208",
        startDate: "2025-01-05",
        nextPaymentDate: "2025-07-05"
      }
    ],
    isExpanded: false
  },
  {
    number: "209",
    residents: [
      {
      id: "209-1",
      name: "Nazwa Carissa Az-zahra",
      phone: "085376721931",
      study: "Kimia NK/2023",
      position: 1,
      paymentPattern: 4,
      paymentPeriods: [
        {
          id: "209-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2023-12-15",
          paymentProofDate: "2024-12-14",
          paymentProofLink: "https://iili.io/2SQuMEg.jpg",
          nextPaymentDate: "2025-04-15"
        },
        {
          id: "209-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-04-15",
          paymentProofDate: "2025-04-22",
          paymentProofLink: "https://cdn.imgchest.com/files/7ogcbqkm8zy.jpeg",
          nextPaymentDate: "2025-08-15"
        }
      ],
      roomNumber: "209",
      startDate: "2023-12-15",
      nextPaymentDate: "2025-08-22"
      },
      {
      id: "209-2",
      name: "Puti Afifa Muskhir",
      phone: "082172036127",
      study: "Pendidikan Biologi/2023",
      position: 2,
      paymentPattern: 4,
      paymentPeriods: [
        {
          id: "209-2-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2023-12-15",
          paymentProofDate: "2024-12-14",
          paymentProofLink: "https://iili.io/2SQuMEg.jpg",
          nextPaymentDate: "2025-04-15"
        },
        {
          id: "209-2-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-04-15",
          paymentProofDate: "2025-04-26",
          paymentProofLink: "https://cdn.imgchest.com/files/7bwckvmk5l7.jpeg",
          nextPaymentDate: "2025-08-15"
        }
      ],
      roomNumber: "209",
      startDate: "2023-12-15",
      nextPaymentDate: "2025-08-26"
      }
    ],
    isExpanded: false
  },
  {
    number: "210",
    residents: [
      {
      id: "210-1",
      name: "Laylatul Hasanah",
      phone: "+62 822-6199-7236",
      study: "Pendidikan Sejarah 2024",
      position: 1,
      paymentPattern: 6,
      paymentPeriods: [
        {
          id: "210-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-08-09",
          paymentProofDate: "2024-08-09",
          paymentProofLink: "https://iili.io/26VPF0F.jpg",
          nextPaymentDate: "2025-02-09"
        },
        {
          id: "210-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-09",
          paymentProofDate: "2025-02-04",
          paymentProofLink: "https://iili.io/3HfBvyP.jpg",
          nextPaymentDate: "2025-08-09"
        }
      ],
      roomNumber: "210",
      startDate: "2024-08-09",
      nextPaymentDate: "2025-08-09"
      },
      {
      id: "210-2",
      name: "Fira Khairatunnisa",
      phone: "+62 831-9324-5824",
      study: "Pendidikan Biologi 2023",
      position: 2,
      paymentPattern: 6,
      paymentPeriods: [
        {
          id: "210-2-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-08-09",
          paymentProofDate: "2024-08-09",
          paymentProofLink: "https://iili.io/26VPF0F.jpg",
          nextPaymentDate: "2025-02-09"
        },
        {
          id: "210-2-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-02-09",
          paymentProofDate: "2025-02-04",
          paymentProofLink: "https://iili.io/3HfBvyP.jpg",
          nextPaymentDate: "2025-08-09"
        }
      ],
      roomNumber: "210",
      startDate: "2024-08-09",
      nextPaymentDate: "2025-08-09"
      }
    ],
    isExpanded: false
  },
  {
    number: "211",
    residents: [{
      id: "211-1",
      name: "Dinny Afrillianti",
      phone: "082288541727",
      study: "Kimia NK 2023",
      position: 1,
      paymentPattern: 4,
      paymentPeriods: [
        {
          id: "211-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-03-21",
          paymentProofDate: "2024-11-23",
          paymentProofLink: "https://iili.io/2SLX5Qa.jpg, https://iili.io/2SLhucl.jpg",
          nextPaymentDate: "2025-03-21"
        },
        {
          id: "211-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-03-20",
          paymentProofDate: "2025-03-20",
          paymentProofLink: "https://iili.io/3zuHEn2.jpg",
          nextPaymentDate: "2025-07-20"
        }
      ],
      roomNumber: "211",
      startDate: "2024-03-21",
      nextPaymentDate: "2025-07-20"
    }],
    isExpanded: false
  },
  {
    number: "212",
    residents: [{
      id: "212-1",
      name: "Ananda Putri Salsabila",
      phone: "085278054510",
      study: "Pendidikan Fisika/2023",
      position: 1,
      paymentPattern: 6,
      paymentPeriods: [
        {
          id: "212-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2023-12-15",
          paymentProofDate: "2024-12-24",
          paymentProofLink: "https://cdn.imgchest.com/files/7ogcbqbaxby.jpeg",
          nextPaymentDate: "2025-06-24"
        }
      ],
      roomNumber: "212",
      startDate: "2023-12-15",
      nextPaymentDate: "2025-06-24"
    }],
    isExpanded: false
  },
  // Third Floor (301-308)
  {
    number: "301",
    residents: [
      {
        id: "301-1",
        name: "Putri Nurhalizah",
        phone: "082288274154",
        study: "Fisika 2021",
        position: 1,
        paymentPattern: 3,
        paymentPeriods: [
          {
            id: "301-1-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-12-22",
            paymentProofDate: "2024-12-22",
            paymentProofLink: "https://iili.io/2SLPS0N.jpg",
            nextPaymentDate: "2025-03-22"
          },
          {
            id: "301-1-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-03-22",
            paymentProofDate: "2025-03-22",
            paymentProofLink: "https://cdn.imgchest.com/files/45xcvg985x7.jpeg",
            nextPaymentDate: "2025-06-22"
          },
          {
            id: "301-1-3",
            periodNumber: 3,
            dpDate: "",
            startDate: "2025-03-22",
            paymentProofDate: "2025-04-15",
            paymentProofLink: "https://cdn.imgchest.com/files/7kzcaobxm97.jpeg",
            nextPaymentDate: "2025-06-22"
          }
        ],
        roomNumber: "301",
        startDate: "2024-12-22",
        nextPaymentDate: "2025-06-22"
      },
      {
        id: "301-2",
        name: "Sahri Ropiah Lubis",
        phone: "085362872619",
        study: "Pend Fisika 2021",
        position: 2,
        paymentPattern: 3,
        paymentPeriods: [
          {
            id: "301-2-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-12-25",
            paymentProofDate: "2024-12-25",
            paymentProofLink: "https://iili.io/2SQXDbt.jpg",
            nextPaymentDate: "2025-03-25"
          },
          {
            id: "301-2-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-03-25",
            paymentProofDate: "2025-03-25",
            paymentProofLink: "https://cdn.imgchest.com/files/y2pckxkqdp7.jpeg",
            nextPaymentDate: "2025-06-25"
          }
        ],
        roomNumber: "301",
        startDate: "2024-12-25",
        nextPaymentDate: "2025-06-25"
      }
    ],
    isExpanded: false
  },
  {
    number: "302",
    residents: [{
      id: "302-1",
      name: "Nabila Fayza",
      phone: "+62 853-6406-0851",
      study: "Matematika NK 2024",
      position: 1,
      paymentPattern: 3,
      startDate: "2025-02-03",
      paymentPeriods: [
        {
          id: "302-1-1",
          periodNumber: 1,
          dpDate: "2025-02-03",
          startDate: "2025-02-03",
          paymentProofDate: "2025-02-03",
          paymentProofLink: "https://iili.io/2tL0G6P.jpg",
          nextPaymentDate: "2025-05-03"
        },
        {
          id: "302-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-05-03",
          paymentProofDate: "2025-05-04",
          paymentProofLink: "https://cdn.imgchest.com/files/45xcvnbp3p7.jpeg",
          nextPaymentDate: "2025-08-04"
        }
      ],
      roomNumber: "302",
      nextPaymentDate: "2025-08-04"
    }],
    isExpanded: false
  },
  {
    number: "303",
    residents: [{
      id: "303-1",
      name: "Ayesha Azzahra Nofedy",
      phone: "+62 822-8803-1846",
      study: "Pendidikan Matematika 2021",
      position: 1,
      paymentPattern: 3,
      paymentPeriods: [
        {
          id: "303-1-1",
          periodNumber: 1,
          dpDate: "",
          startDate: "2024-10-15", 
          paymentProofDate: "2024-10-31",
          paymentProofLink: "https://iili.io/2idPCfS.jpg",
          nextPaymentDate: "2025-01-15"
        },
        {
          id: "303-1-2",
          periodNumber: 2,
          dpDate: "",
          startDate: "2025-01-15",
          paymentProofDate: "2025-02-02",
          paymentProofLink: "https://iili.io/2ZiyMcg.jpg",
          nextPaymentDate: "2025-04-15"
        },
        {
          id: "303-1-3",
          periodNumber: 3,
          dpDate: "",
          startDate: "2025-04-15",
          paymentProofDate: "2025-05-01",
          paymentProofLink: "https://cdn.imgchest.com/files/7pjcq9lb5k7.jpeg",
          nextPaymentDate: "2025-08-01"
        }
      ],
      roomNumber: "303",
      startDate: "2024-10-15",
      nextPaymentDate: "2025-08-01"
    }],
    isExpanded: false
  },
  {
    number: "304",
    residents: [
      {
        id: "304-1",
        name: "ludfi atika",
        phone: "+62 857-1230-8512",
        study: "",
        position: 1,
        paymentPattern: 3,
        paymentPeriods: [
          {
            id: "304-1-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2025-02-13",
            paymentProofDate: "2025-02-17",
            paymentProofLink: "https://iili.io/32ev7rQ.jpg",
            nextPaymentDate: "2025-05-13"
          },
          {
            id: "304-1-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-05-13",
            paymentProofDate: "2025-05-16",
            paymentProofLink: "https://cdn.imgchest.com/files/4nec82dexr4.jpeg",
            nextPaymentDate: "2025-08-16"
          }
        ],
        roomNumber: "304",
        startDate: "2025-02-13",
        nextPaymentDate: "2025-08-16"
      }
    ],
    isExpanded: false
  },
  {
    number: "305",
    residents: [
      {
        id: "305-1",
        name: "Masya Rizki Putri",
        phone: "081275194193",
        study: "PGSD 22",
        position: 1,
        paymentPattern: 6,
        paymentPeriods: [
          {
            id: "305-1-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-08-05",
            paymentProofDate: "2024-08-05",
            paymentProofLink: "https://iili.io/2SQlA5g.jpg",
            nextPaymentDate: "2025-02-05"
          },
          {
            id: "305-1-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-02-05",
            paymentProofDate: "2025-02-06",
            paymentProofLink: "https://iili.io/3Hqf37I.jpg",
            nextPaymentDate: "2025-08-05"
          }
        ],
        roomNumber: "305",
        startDate: "2024-08-05",
        nextPaymentDate: "2025-08-05"
      },
      {
        id: "305-2",
        name: "Dilla Dwi Zulvani",
        phone: "081264429462",
        study: "Biologi 2023",
        position: 2,
        paymentPattern: 6,
        paymentPeriods: [
          {
            id: "305-2-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-08-05",
            paymentProofDate: "2024-08-05",
            paymentProofLink: "https://iili.io/2SQlA5g.jpg",
            nextPaymentDate: "2025-02-05"
          },
          {
            id: "305-2-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-02-05",
            paymentProofDate: "2025-02-06",
            paymentProofLink: "https://iili.io/3Hqf37I.jpg",
            nextPaymentDate: "2025-08-05"
          }
        ],
        roomNumber: "305",
        startDate: "2024-08-05",
        nextPaymentDate: "2025-08-05"
      }
    ],
    isExpanded: false
  },
  {
    number: "306",
    residents: [
      {
        id: "306-2",
        name: "Nur Hafizah",
        phone: "+62 85363782499",
        study: "Teknik Sipil 2023",
        position: 2,
        paymentPattern: 4,
        paymentPeriods: [
          {
            id: "306-2-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-12-25",
            paymentProofDate: "2024-12-25",
            paymentProofLink: "https://iili.io/2idIMEx.jpg",
            nextPaymentDate: "2025-04-25"
          },
          {
            id: "306-2-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-04-25",
            paymentProofDate: "2025-04-25",
            paymentProofLink: "https://cdn.imgchest.com/files/7ogcbqepddy.jpeg",
            nextPaymentDate: "2025-08-25"
          }
        ],
        roomNumber: "306",
        startDate: "2024-12-25",
        nextPaymentDate: "2025-08-25"
      }
    ],
    isExpanded: false
  },
  {
    number: "307",
    residents: [],
    isExpanded: false
  },
  {
    number: "308",
    residents: [
      {
        id: "308-2",
        name: "Laila Nur Aini",
        phone: "085767224085",
        study: "Akuntansi (NK) 24",
        position: 1,
        paymentPattern: 1,
        paymentPeriods: [
          {
            id: "308-2-1",
            periodNumber: 1,
            dpDate: "",
            startDate: "2024-08-16",
            paymentProofDate: "2024-08-16",
            paymentProofLink: "https://iili.io/2SLOHbI.jpg",
            nextPaymentDate: "2025-02-16"
          },
          {
            id: "308-2-2",
            periodNumber: 2,
            dpDate: "",
            startDate: "2025-02-16",
            paymentProofDate: "2025-02-16",
            paymentProofLink: "https://iili.io/3Hf1YMv.jpg",
            nextPaymentDate: "2025-05-16"
          },
          {
            id: "308-2-3",
            periodNumber: 3,
            dpDate: "",
            startDate: "2025-05-16",
            paymentProofDate: "2025-05-17",
            paymentProofLink: "https://cdn.imgchest.com/files/yd5celpdkk4.jpeg",
            nextPaymentDate: "2025-06-17"
          }
        ],
        roomNumber: "308",
        startDate: "2024-08-16",
        nextPaymentDate: "2025-06-17"
      }
    ],
    isExpanded: false
  }
];

// Function to clear all data from Supabase
export async function clearSupabaseData() {
  try {
    console.log('🧹 Clearing all data from Supabase...');
    
    // Clear in correct order (foreign key constraints)
    await supabase.from('payment_periods').delete().neq('id', '00000000-0000-0000-0000-000000000000');
    await supabase.from('residents').delete().neq('id', '00000000-0000-0000-0000-000000000000');
    await supabase.from('rooms').delete().neq('id', '00000000-0000-0000-0000-000000000000');
    
    console.log('✅ All data cleared from Supabase');
    return { success: true };
  } catch (error) {
    console.error('❌ Error clearing Supabase data:', error);
    return { success: false, error: error instanceof Error ? error.message : 'Unknown error' };
  }
}

export async function migrateCompleteFloorDataToSupabase() {
  try {
    console.log('🚀 Starting COMPLETE floor data migration to Supabase...');
    console.log(`📊 Total rooms to migrate: ${completeFloorData.length}`);

    // First, clear existing data in correct order (foreign key constraints)
    console.log('🧹 Clearing existing data...');
    await clearSupabaseData();

    console.log('✅ Cleared existing data');

    let totalRoomsMigrated = 0;
    let totalResidentsMigrated = 0;
    let totalPaymentPeriodsMigrated = 0;

    // Migrate all rooms and their data
    for (const room of completeFloorData) {
      try {
        // Insert room
        const { data: roomData, error: roomError } = await supabase
          .from('rooms')
          .insert({
            number: room.number,
            is_expanded: room.isExpanded || false
          })
          .select('id')
          .single();

        if (roomError) {
          console.error(`❌ Error inserting room ${room.number}:`, roomError);
          continue;
        }

        totalRoomsMigrated++;
        console.log(`🏠 Migrated room ${room.number}`);

        // Migrate residents for this room
        for (const resident of room.residents || []) {
          // Skip completely empty residents
          if (!resident.name || !resident.name.trim()) {
            console.log(`⏭️  Skipping empty resident in room ${room.number}`);
            continue;
          }

          try {
            const { data: residentData, error: residentError } = await supabase
              .from('residents')
              .insert({
                room_id: roomData.id,
                name: resident.name.trim(),
                phone: resident.phone || '',
                study: resident.study || '',
                position: resident.position,
                payment_pattern: resident.paymentPattern || 1,
                start_date: resident.startDate || null,
                next_payment_date: resident.nextPaymentDate || null
              })
              .select('id')
              .single();

            if (residentError) {
              console.error(`❌ Error inserting resident ${resident.name}:`, residentError);
              continue;
            }

            totalResidentsMigrated++;
            console.log(`👤 Migrated resident: ${resident.name} (Room ${room.number}, Position ${resident.position})`);

            // Migrate payment periods for this resident
            for (const period of resident.paymentPeriods || []) {
              try {
                const { error: periodError } = await supabase
                  .from('payment_periods')
                  .insert({
                    resident_id: residentData.id,
                    period_number: period.periodNumber,
                    dp_date: period.dpDate || null,
                    start_date: period.startDate || null,
                    payment_proof_date: period.paymentProofDate || null,
                    payment_proof_link: period.paymentProofLink || '',
                    next_payment_date: period.nextPaymentDate || null
                  });

                if (periodError) {
                  console.error(`❌ Error inserting payment period ${period.periodNumber} for ${resident.name}:`, periodError);
                  continue;
                }

                totalPaymentPeriodsMigrated++;
                console.log(`💰 Migrated payment period ${period.periodNumber} for ${resident.name}`);
              } catch (periodErr) {
                console.error(`❌ Exception during payment period migration:`, periodErr);
              }
            }
          } catch (residentErr) {
            console.error(`❌ Exception during resident migration:`, residentErr);
          }
        }
      } catch (roomErr) {
        console.error(`❌ Exception during room migration:`, roomErr);
      }
    }

    console.log('🎉 COMPLETE data migration finished successfully!');
    console.log(`📈 Final Migration Summary:`);
    console.log(`   🏠 Rooms migrated: ${totalRoomsMigrated}`);
    console.log(`   👤 Residents migrated: ${totalResidentsMigrated}`);
    console.log(`   💰 Payment periods migrated: ${totalPaymentPeriodsMigrated}`);
    
    return {
      success: true,
      stats: {
        rooms: totalRoomsMigrated,
        residents: totalResidentsMigrated,
        paymentPeriods: totalPaymentPeriodsMigrated
      }
    };
  } catch (error) {
    console.error('💥 Error during complete data migration:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
}

// Function to run migration with user confirmation
export async function runCompleteFloorDataMigration() {
  console.log('🚀 Starting COMPLETE migration process...');
  const result = await migrateCompleteFloorDataToSupabase();
  
  if (result.success) {
    alert(
      `✅ COMPLETE Migration berhasil!\n\n` +
      `📊 Hasil:\n` +
      `• Kamar: ${result.stats?.rooms}\n` +
      `• Penghuni: ${result.stats?.residents}\n` +
      `• Periode Pembayaran: ${result.stats?.paymentPeriods}\n\n` +
      `Halaman akan dimuat ulang untuk menampilkan data baru.`
    );
    window.location.reload();
  } else {
    alert(
      `❌ Migration gagal!\n\n` +
      `Error: ${result.error}\n\n` +
      `Silakan periksa console untuk informasi error yang detail.`
    );
  }
  
  return result;
}

// Legacy function for backward compatibility
export async function runFloorDataMigration() {
  return await runCompleteFloorDataMigration();
}

// Make it available globally for easy access
(window as any).runCompleteFloorDataMigration = runCompleteFloorDataMigration;
(window as any).runFloorDataMigration = runCompleteFloorDataMigration;
(window as any).migrateFloorData = runCompleteFloorDataMigration;
(window as any).clearSupabaseData = clearSupabaseData;

// Auto-run migration check on load
console.log('🔧 COMPLETE Floor data migration utility loaded!');
console.log('📝 To migrate ALL data, run: runCompleteFloorDataMigration()');
console.log('📝 To clear database, run: clearSupabaseData()');
console.log('📝 Or use shortcuts: runFloorDataMigration() or migrateFloorData()');